import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import ManagerDataService from "../services/manager.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useAuth0 } from '@auth0/auth0-react';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useToast } from './common/Toast';
import logger from '../utils/logger';

const HomeMng = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const { showSuccess, showError, showWarning, ToastContainer } = useToast();
  
  // Refs pour les formulaires
  const formRef = useRef();
  const formRefTarif = useRef();
  const formRefPlann = useRef();
  const formRefQuota = useRef();
  const formRefAddIndis = useRef();
  const formRefEndIndis = useRef();
  const formRefExtendIndis = useRef();

  // État du composant avec useState
  const [state, setState] = useState({
    habilitation: [],
    mngdisplay: [],
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    weekDay2: [{"value": 2,"label": "Lundi"},{"value": 3,"label": "Mardi"},{"value": 4,"label": "Mercredi"},{"value": 5,"label": "Jeudi"},{"value": 6,"label": "Vendredi"},{"value": 7,"label": "Samedi"},{"value": 1,"label": "Dimanche"}],
    showModal: false,
    showModalPlann: false,
    showModalTarif: false,
    showModalQuota: false,
    showModalDeletePlann: false,
    showModalAddIndis: false,
    showModalEndIndis: false,
    showModalExtendIndis: false,
    service: [],
    optionsDoc: [],
    idservice: null,
    iddoctor: null,
    jour: null,
    hdeb: null,
    hfin: null,
    mindeb: null,
    minfin: null,
    maxpatient: null,
    mess_erreur: '',
    libstr_u: null,
    libser_u: null,
    doc_u: null,
    tarif_u: null,
    idplanning_u: null,
    isLoading: true,
    erreur: null,
    idplann_u: null, //pour update maxpatient, delete plann et add indis
    debutIndis: null,
    finIndis: null,
    motifIndis: null,
    debutIndis_u: null,
    motifIndis_u: null,
    finIndis2: null, //pour terminer indisponibilité définitive
    finIndis_u: null,
    finIndis3: null, //pour prolonger indiponibilité provisoire
    idindis: null,
    id_medecin_u: null
  });

  // useEffect pour remplacer componentDidMount
  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email"
        });
        
        const http = require("../http-common").default;
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        await Promise.all([
          getHabilitation(),
          getMngDisplay(),
          getService(),
          getAllDoctors()
        ]);
        
        setState(prev => ({ ...prev, isLoading: false }));
      } catch (error) {
        logger.error('Erreur récupération token:', error);
        showError('Erreur d\'authentification');
        setState(prev => ({ ...prev, isLoading: false, erreur: error.message }));
      }
    };

    if (user) {
      initializeComponent();
    }
  }, [user, getAccessTokenSilently]);

  // Handler functions
  const handleShow = () => setState(prev => ({
    ...prev,
    // reset des champs du formulaire à l'ouverture
    idservice: null,
    iddoctor: null,
    jour: null,
    hdeb: null,
    hfin: null,
    tarif_u: null,
    maxpatient: null,
    mess_erreur: '',
    showModal: true
  }));

  const handleClose = () => setState(prev => ({ ...prev, showModal: false }));

  const handleShowTarif = (libstr, libser, titre, nom, prenom, idplanning, prix) => {
    console.log('handleShowTarif called with:', { libstr, libser, titre, nom, prenom, idplanning, prix });
    setState(prev => ({
      ...prev,
      libstr_u: libstr,
      libser_u: libser,
      doc_u: titre + ' ' + nom + ' ' + prenom,
      tarif_u: prix,
      idplanning_u: idplanning,
      showModalTarif: true
    }));
  };
  
  const handleCloseTarif = () => setState(prev => ({ ...prev, showModalTarif: false }));

  const handleShowQuota = (libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota) => {
    console.log('handleShowQuota called with:', { libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota });
    setState(prev => ({
      ...prev,
      libstr_u: libstr,
      libser_u: libser,
      doc_u: titre + ' ' + nom + ' ' + prenom,
      idplann_u: idplann,
      jour: jour,
      hdeb: deb,
      hfin: fin,
      maxpatient: quota,
      showModalQuota: true
    }));
  };

  const handleCloseQuota = () => {
    setState(prev => ({ 
      ...prev, 
      showModalQuota: false,
      mess_erreur: null
    }));
  };

  const handleShowDeletePlann = (libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota) => {
    console.log('handleShowDeletePlann called with:', { libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota });
    setState(prev => ({
      ...prev,
      libstr_u: libstr,
      libser_u: libser,
      doc_u: titre + ' ' + nom + ' ' + prenom,
      idplann_u: idplann,
      jour: jour,
      hdeb: deb,
      hfin: fin,
      maxpatient: quota,
      showModalDeletePlann: true,
      mess_erreur: 'Etes-vous certain de vouloir supprimer?'
    }));
  };

  const handleCloseDeletePlann = () => {
    setState(prev => ({ 
      ...prev, 
      showModalDeletePlann: false,
      mess_erreur: null
    }));
  };

  const handleShowAddIndis = (libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota) => {
    console.log('handleShowAddIndis called with:', { libstr, libser, titre, nom, prenom, idplann, jour, deb, fin, quota });
    setState(prev => ({
      ...prev,
      libstr_u: libstr,
      libser_u: libser,
      doc_u: titre + ' ' + nom + ' ' + prenom,
      idplann_u: idplann,
      jour: jour,
      hdeb: deb,
      hfin: fin,
      maxpatient: quota,
      // reset du formulaire d'indisponibilité à l'ouverture
      debutIndis: null,
      finIndis: null,
      motifIndis: '',
      mess_erreur: 'Les éventuels rendez-vous prévus au cours de la période renseignée seront annulés.', 
      showModalAddIndis: true
    }));
  };

  const handleCloseAddIndis = () => setState(prev => ({ ...prev, showModalAddIndis: false }));

  const handleShowEndIndis = (libstr, libser, titre, nom, prenom, jour, hdeb, hfin, maxpatient, indisplann, indisdebut, motif) => {
    console.log('handleShowEndIndis called with:', { libstr, libser, titre, nom, prenom, jour, hdeb, hfin, maxpatient, indisplann, indisdebut, motif });
    setState(prev => ({
      ...prev, libstr_u: libstr, libser_u: libser, doc_u: titre + ' ' + nom + ' ' + prenom,
      jour: jour, hdeb: hdeb, hfin: hfin, maxpatient: maxpatient, indisplann_u: indisplann, indisdebut_u: indisdebut, motif_u: motif, 
      // reset champ de fin pour terminer la suspension
      finIndis2: null,
      showModalEndIndis: true
    }));
  };

  const handleCloseEndIndis = () => setState(prev => ({ ...prev, showModalEndIndis: false }));

  const handleShowExtendIndis = (libstr, libser, titre, nom, prenom, jour, hdeb, hfin, maxpatient, indisplann, indisdebut, indisfin, motif) => {
    console.log('handleShowExtendIndis called with:', { libstr, libser, titre, nom, prenom, jour, hdeb, hfin, maxpatient, indisplann, indisdebut, indisfin, motif });
    setState(prev => ({
      ...prev, libstr_u: libstr, libser_u: libser, doc_u: titre + ' ' + nom + ' ' + prenom,
      jour: jour, hdeb: hdeb, hfin: hfin, maxpatient: maxpatient, indisplann_u: indisplann, indisdebut_u: indisdebut, indisfin_u: indisfin, motif_u: motif,
      // reset champ de prolongation
      finIndis3: null,
      mess_erreur: 'Les éventuels rendez-vous prévus au cours de la période renseignée seront annulés.', 
      showModalExtendIndis: true
    }));
  };

  const handleCloseExtendIndis = () => setState(prev => ({ ...prev, showModalExtendIndis: false }));

  const handleShowPlann = (libstr, libser, titre, nom, prenom, idplanning, id_medecin) => {
    console.log('handleShowPlann called with:', { libstr, libser, titre, nom, prenom, idplanning, id_medecin });
    setState(prev => ({
      ...prev, 
      libstr_u: libstr, 
      libser_u: libser, 
      doc_u: titre + ' ' + nom + ' ' + prenom,
      idplanning_u: idplanning,
      id_medecin_u: id_medecin,
      // reset des champs du formulaire à l'ouverture
      hdeb: null,
      hfin: null,
      maxpatient: null,
      mess_erreur: '',
      showModalPlann: true
    }));
  };

  const handleClosePlann = () => setState(prev => ({ ...prev, showModalPlann: false }));

  // Handlers pour les changements de formulaire
  const onChangeTarif_u = (e) => setState(prev => ({ ...prev, tarif_u: e.target.value }));
  const onChangeMaxpatient = (e) => setState(prev => ({ ...prev, maxpatient: e.target.value }));
  const onChangeService = (e) => setState(prev => ({ ...prev, idservice: e.value }));
  const onChangeDoctor = (e) => setState(prev => ({ ...prev, iddoctor: e.value }));
  const onChangeJour = (opt) => setState(prev => ({ ...prev, jour: opt ? opt.value : null }));
  const onChangeHdeb = (e) => setState(prev => ({ ...prev, hdeb: e.target.value }));
  const onChangeHfin = (e) => setState(prev => ({ ...prev, hfin: e.target.value }));

  // Handlers formulaire indisponibilité
  const onChangeDebutIndis = (date) => setState(prev => ({ ...prev, debutIndis: date }));
  const onChangeFinIndis = (date) => setState(prev => ({ ...prev, finIndis: date }));
  const onChangeMotifIndis = (e) => setState(prev => ({ ...prev, motifIndis: e.target.value }));

  // Handler DatePicker nouvelle fin (prolongation)
  const onChangeFinIndis3 = (date) => setState(prev => ({ ...prev, finIndis3: date }));

  // Handler DatePicker fin (terminer la suspension)
  const onChangeFinIndis2 = (date) => setState(prev => ({ ...prev, finIndis2: date }));

  // Validation formulaire ajout de prestation
  const isPrestationFormValid = Boolean(
    state.idservice &&
    state.iddoctor &&
    state.jour &&
    state.hdeb &&
    state.hfin &&
    Number(state.tarif_u) > 0 &&
    Number(state.maxpatient) > 0 &&
    state.hdeb < state.hfin
  );

  // Validation formulaire ajouter un créneau
  const isPlannFormValid = Boolean(
    state.jour &&
    state.hdeb &&
    state.hfin &&
    Number(state.maxpatient) > 0 &&
    state.hdeb < state.hfin
  );

  // Validation formulaire ajout indisponibilité (fin optionnelle)
  const isAddIndisFormValid = Boolean(
    state.debutIndis instanceof Date &&
    state.motifIndis &&
    (!state.finIndis || (state.finIndis instanceof Date && state.debutIndis <= state.finIndis))
  );

  // Validation prolongation: nouvelle fin requise et strictement > fin actuelle
  const isExtendIndisFormValid = (() => {
    if (!(state.finIndis3 instanceof Date)) return false;
    if (!state.indisfin_u) return false;
    const currentEnd = new Date(state.indisfin_u);
    return state.finIndis3 > currentEnd; // strictement supérieure
  })();

  // Validation terminer suspension: fin >= début ET fin >= aujourd'hui
  const isEndIndisFormValid = (() => {
    if (!(state.finIndis2 instanceof Date)) return false;
    const today = new Date(); today.setHours(0,0,0,0);
    const start = state.indisdebut_u ? new Date(state.indisdebut_u) : null;
    if (start) start.setHours(0,0,0,0);
    const fin = new Date(state.finIndis2); fin.setHours(0,0,0,0);
    return fin >= today && (!start || fin >= start);
  })();

  // Actions modals
  const saveTarif = async () => {
    try {
      await ManagerDataService.updateTarif(state.tarif_u, user.email, state.idplanning_u);
      showSuccess('Tarif mis à jour');
      setState(prev => ({ ...prev, showModalTarif: false }));
      await getMngDisplay();
    } catch (error) {
      logger.error('Erreur mise à jour tarif:', error);
      showError('Échec de la mise à jour du tarif');
    }
  };

  const saveQuota = async () => {
    try {
      await ManagerDataService.updateQuota(state.maxpatient, user.email, state.idplann_u);
      showSuccess('Limite patients mise à jour');
      setState(prev => ({ ...prev, showModalQuota: false }));
      await getMngDisplay();
    } catch (error) {
      logger.error('Erreur mise à jour quota:', error);
      showError('Échec de la mise à jour de la limite patients');
    }
  };

  const confirmDeletePlann = async () => {
    try {
      const resp = await ManagerDataService.deletePlann(state.idplann_u, user.email);
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        showSuccess('Créneau supprimé');
        setState(prev => ({ ...prev, showModalDeletePlann: false, mess_erreur: null }));
        await getMngDisplay();
      } else {
        const msg = 'Des rendez-vous ont été pris pour ce créneau. Impossible de le supprimer.';
        setState(prev => ({ ...prev, mess_erreur: msg }));
      }
    } catch (error) {
      logger.error('Erreur suppression créneau:', error);
      showError('Échec de la suppression du créneau');
    }
  };

  const savePrestation = async () => {
    try {
      // validations minimales
      if (!state.idservice || !state.iddoctor || !state.jour || !state.hdeb || !state.hfin || !state.tarif_u || !state.maxpatient) {
        setState(prev => ({ ...prev, mess_erreur: 'Veuillez remplir tous les champs requis.' }));
        return;
      }
      const resp = await ManagerDataService.addPlanningPlann(
        state.idservice,
        state.iddoctor,
        state.tarif_u,
        state.jour,
        state.hdeb,
        state.hfin,
        state.maxpatient,
        user.email
      );
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        // Conflit horaire pour ce médecin
        setState(prev => ({ ...prev, mess_erreur: 'Plage horraire indisponible pour ce médecin.' }));
        return;
      }
      showSuccess('Prestation ajoutée');
      // reset formulaire minimal
      setState(prev => ({
        ...prev,
        showModal: false,
        mess_erreur: '',
        idservice: null,
        iddoctor: null,
        jour: null,
        hdeb: null,
        hfin: null,
        tarif_u: null,
        maxpatient: null
      }));
      await getMngDisplay();
    } catch (error) {
      logger.error('Erreur ajout prestation:', error);
      showError("Échec de l'ajout de la prestation");
      setState(prev => ({ ...prev, mess_erreur: "Impossible d'ajouter la prestation. Réessayez." }));
    }
  };

  const savePlann = async () => {
    try {
      if (!isPlannFormValid) {
        setState(prev => ({ ...prev, mess_erreur: 'Veuillez vérifier les champs requis (jour, heures, limite patients).' }));
        return;
      }
      const resp = await ManagerDataService.addPlann(
        state.idplanning_u,
        state.id_medecin_u,
        state.jour,
        state.hdeb,
        state.hfin,
        state.maxpatient,
        user.email
      );
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        setState(prev => ({ ...prev, mess_erreur: 'Plage horraire indisponible pour ce médecin.' }));
        return;
      }
      showSuccess('Créneau ajouté');
      setState(prev => ({
        ...prev,
        showModalPlann: false,
        mess_erreur: '',
        jour: null,
        hdeb: null,
        hfin: null,
        maxpatient: null
      }));
      await getMngDisplay();
    } catch (error) {
      logger.error('Erreur ajout créneau:', error);
      showError('Échec de l\'ajout du créneau');
      setState(prev => ({ ...prev, mess_erreur: 'Impossible d\'ajouter le créneau. Réessayez.' }));
    }
  };

  const saveAddIndis = async () => {
    try {
      if (!isAddIndisFormValid) {
        setState(prev => ({ ...prev, mess_erreur: 'Veuillez renseigner un début, une fin et un motif valides.' }));
        return;
      }
      // Formater au format attendu backend 'YYYY-MM-DD HH:mm' (fin optionnelle)
        const debut = dayjs(state.debutIndis).format('YYYY-MM-DD HH:mm');
        const fin = state.finIndis ? dayjs(state.finIndis).format('YYYY-MM-DD HH:mm') : '';
        const resp = await ManagerDataService.addIndisPlann(
        debut,
        fin,
        state.motifIndis,
        state.idplann_u,
        user.email
        );
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        setState(prev => ({ ...prev, mess_erreur: 'Plage déjà indisponible sur cette période.' }));
        return;
      }
      showSuccess('Indisponibilité ajoutée');
      setState(prev => ({
        ...prev,
        showModalAddIndis: false,
        mess_erreur: '',
        debutIndis: null,
        finIndis: null,
        motifIndis: ''
      }));
      await getMngDisplay();
    } catch (error) {
      logger.error("Erreur ajout indisponibilité:", error);
      showError("Échec de l'ajout de l'indisponibilité");
      setState(prev => ({ ...prev, mess_erreur: "Impossible d'ajouter l'indisponibilité. Réessayez." }));
    }
  };

  // Sauvegarde prolongation
  const saveExtendIndis = async () => {
    try {
      if (!isExtendIndisFormValid) {
        setState(prev => ({ ...prev, mess_erreur: 'Veuillez choisir une nouvelle date de fin strictement postérieure à la fin actuelle.' }));
        return;
      }
      const fin = dayjs(state.finIndis3).format('YYYY-MM-DD HH:mm');
      const resp = await ManagerDataService.extendIndisPlann(
        fin,
        state.indisplann_u,
        user.email
      );
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        setState(prev => ({ ...prev, mess_erreur: 'Impossible de prolonger: la nouvelle fin chevauche une période non autorisée.' }));
        return;
      }
      showSuccess('Indisponibilité prolongée');
      setState(prev => ({ ...prev, showModalExtendIndis: false, mess_erreur: '', finIndis3: null }));
      await getMngDisplay();
    } catch (error) {
      logger.error("Erreur prolongation indisponibilité:", error);
      showError("Échec de la prolongation de l'indisponibilité");
      setState(prev => ({ ...prev, mess_erreur: "Impossible de prolonger l'indisponibilité. Réessayez." }));
    }
  };

  // Terminer la suspension
  const saveEndIndis = async () => {
    try {
      if (!isEndIndisFormValid) return;
      const fin = dayjs(state.finIndis2).format('YYYY-MM-DD HH:mm');
      const resp = await ManagerDataService.endIndisPlann(
        fin,
        user.email,
        state.indisplann_u
      );
      const data = resp?.data;
      const result = Array.isArray(data) ? data[0]?.result : data?.result;
      if (result === 0) {
        showError("Impossible de terminer l'indisponibilité");
        return;
      }
      showSuccess("Indisponibilité terminée");
      setState(prev => ({ ...prev, showModalEndIndis: false, finIndis2: null }));
      await getMngDisplay();
    } catch (error) {
      logger.error("Erreur fin d'indisponibilité:", error);
      showError("Échec de la fin d'indisponibilité");
    }
  };

  // Méthodes API principales
  const getHabilitation = async () => {
    try {
      const response = await ManagerDataService.habilitation(user.email);
      setState(prev => ({ ...prev, habilitation: response.data[0] }));
      logger.log('Habilitation récupérée:', response.data[0]);
    } catch (error) {
      logger.error('Erreur récupération habilitation:', error);
      showError('Erreur lors de la récupération des habilitations');
    }
  };

  const getMngDisplay = async () => {
    try {
      const response = await ManagerDataService.mngdisplay(user.email);
      setState(prev => ({ ...prev, mngdisplay: response.data, isLoading: false }));
      logger.log('MngDisplay récupéré:', response.data);
    } catch (error) {
      logger.error('Erreur récupération mngdisplay:', error);
      setState(prev => ({ ...prev, erreur: error.message, isLoading: false }));
      showError('Erreur lors de la récupération des données');
    }
  };

  const getService = async () => {
    try {
      const response = await ManagerDataService.service(user.email);
      // Normalisation au format react-select {value,label}
      const serviceOptions = Array.isArray(response.data)
        ? response.data.map((s) => ({
            value: s.value ?? s.idservice,
            label: s.label ?? s.libelle_service,
          }))
        : [];
      setState(prev => ({ ...prev, service: serviceOptions }));
      logger.log('Services récupérés:', response.data);
    } catch (error) {
      logger.error('Erreur récupération services:', error);
      showError('Erreur lors de la récupération des services');
    }
  };

  const getAllDoctors = async () => {
    try {
      const response = await ManagerDataService.allDoctors();
      // Normalisation au format react-select {value,label}
      const doctorOptions = Array.isArray(response.data)
        ? response.data.map((d) => ({
            value: d.value ?? d.id_medecin,
            label: d.label ?? `${d.titre || ''} ${d.nom || ''} ${d.prenom || ''}`.trim(),
          }))
        : [];
      setState(prev => ({ ...prev, optionsDoc: doctorOptions }));
      logger.log('Médecins récupérés:', response.data);
    } catch (error) {
      logger.error('Erreur récupération médecins:', error);
      showError('Erreur lors de la récupération des médecins');
    }
  };

  // Affichage conditionnel pendant le chargement
  if (state.isLoading) {
    return (
      <div className="col-md-12 mx-auto">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }

  if (state.erreur) {
    return (
      <div className="col-md-12 mx-auto">
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Erreur!</h4>
          <p>Une erreur s'est produite lors du chargement des données.</p>
          <p className="mb-0">{state.erreur}</p>
        </div>
        <ToastContainer />
      </div>
    );
  }

  return (
    <div className="col-md-12 mx-auto">
      <div className="row mx-auto" style={{ backgroundColor: "#6f42c1", color: "white", padding: "20px" }}>
        <span style={{ fontSize: "1.5rem" }} className="lead"><FontAwesomeIcon icon={solid('calendar')} size="2x"/> <b>Planning de consultations</b></span>
      </div>
      <div className="row mx-auto" style={{ padding: "20px" }}>
        <div className="col-12">
          <div className="mb-3">
            <Button variant="primary" onClick={handleShow}>
              <FontAwesomeIcon icon={solid('plus')} />
            </Button>
          </div>

          {state.mngdisplay && state.mngdisplay.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th scope="col">Service médical</th>
                    <th scope="col">Praticien</th>
                    <th scope="col">Jour</th>
                    <th scope="col">Horraire</th>
                    <th scope="col">Limite patients</th>
                    <th scope="col">Suspension</th>
                  </tr>
                </thead>
                <tbody>
                  {state.mngdisplay && state.mngdisplay.map((plann, index) => {
                    if (index === 0) {
                      if (plann.indisplann) { 
                        /*il y a indisponibilité*/
                        if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                          /*indisponibilité définitive*/
                          return (<React.Fragment key={`groupe_${plann.idplann}`}>
                              <tr key={plann.idplann + '_a'} className="table-info">
                                <td style={{ textAlign: 'center' }} colSpan={6}>
                                  <b>
                                    <i>{plann.libelle_structure}</i>
                                  </b>
                                </td>
                              </tr>
                              <tr key={plann.idplann}>
                                <td>{plann.libelle_service}</td>
                                <td>
                                  <div className="dropdown">
                                    <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {plann.titre+' '+plann.nom+' '+plann.prenom}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                      <li><hr className="dropdown-divider"/></li>
                                      <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                    </ul>
                                  </div>
                                </td>
                                <td>{state.weekDay[plann.jour]}</td>
                                <td className="text-danger">
                                  {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                </td>
                                <td className="text-danger">{plann.max_patient}</td>
                                <td className="text-danger">
                                  <div className="dropdown">
                                    <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        }
                        else {
                          /*indisponibilité provisoire*/
                          return (<React.Fragment key={`groupe_${plann.idplann}`}>
                              <tr key={plann.idplann + '_a'} className="table-info">
                                <td style={{ textAlign: 'center' }} colSpan={6}>
                                  <b>
                                    <i>{plann.libelle_structure}</i>
                                  </b>
                                </td>
                              </tr>
                              <tr key={plann.idplann}>
                                <td>{plann.libelle_service}</td>
                                <td>
                                  <div className="dropdown">
                                    <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {plann.titre+' '+plann.nom+' '+plann.prenom}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                      <li><hr className="dropdown-divider"/></li>
                                      <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                    </ul>
                                  </div>
                                </td>
                                <td>{state.weekDay[plann.jour]}</td>
                                <td className="text-warning">
                                  <div className="dropdown">
                                    <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                      <li><hr className="dropdown-divider"/></li>
                                      <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                    </ul>
                                  </div>
                                </td>
                                <td className="text-warning">{plann.max_patient}</td>
                                <td className="text-warning">
                                  <div className="dropdown">
                                    <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        }
                      }
                      else {
                        /*aucune indisponibilité en cours*/
                        return (<React.Fragment key={`groupe_${plann.idplann}`}>
                            <tr key={plann.idplann + '_a'} className="table-info">
                              <td style={{ textAlign: 'center' }} colSpan={6}>
                                <b>
                                  <i>{plann.libelle_structure}</i>
                                </b>
                              </td>
                            </tr>
                            <tr key={plann.idplann}>
                              <td>{plann.libelle_service}</td>
                              <td>
                                <div className="dropdown">
                                  <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {plann.titre+' '+plann.nom+' '+plann.prenom}
                                  </button>
                                  <ul className="dropdown-menu">
                                    <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                    <li><hr className="dropdown-divider"/></li>
                                    <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                  </ul>
                                </div>
                              </td>
                              <td>{state.weekDay[plann.jour]}</td>
                              <td>
                                <div className="dropdown">
                                  <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                  </button>
                                  <ul className="dropdown-menu">
                                    <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                    <li><hr className="dropdown-divider"/></li>
                                    <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                    <li><hr className="dropdown-divider"/></li>
                                    <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowAddIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Ajouter une indisponibilité</button></li>
                                  </ul>
                                </div>
                              </td>
                              <td>{plann.max_patient}</td>
                              <td></td>
                            </tr>
                          </React.Fragment>
                        );
                      }
                    } 
                    else {
                      // Complex nested logic for subsequent rows
                      if (plann.idstr === state.mngdisplay[index-1].idstr) {
                        // MÊME STRUCTURE - pas d'entête, juste lignes simples
                        if (plann.idser === state.mngdisplay[index-1].idser) {
                            //meme service
                          if (plann.id_medecin === state.mngdisplay[index-1].id_medecin) {
                            //meme médecin
                            if (plann.jour === state.mngdisplay[index-1].jour) {
                                //meme jour
                                if (plann.indisplann) { 
                                    /*il y a indisponibilité*/
                                    if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                                      /*indisponibilité définitive*/
                                      return (<tr key={plann.idplann}>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="text-danger">
                                              {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                            </td>
                                            <td className="text-danger">{plann.max_patient}</td>
                                            <td className="text-danger">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                          </tr>
                                      );
                                    }
                                    else {
                                      /*indisponibilité provisoire*/
                                      return (<tr key={plann.idplann}>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="text-warning">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                  {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                                  <li><hr className="dropdown-divider"/></li>
                                                  <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                            <td className="text-warning">{plann.max_patient}</td>
                                            <td className="text-warning">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                          </tr>
                                      );
                                    }
                                  }
                                  else {
                                    /*aucune indisponibilité en cours*/
                                    return (<tr key={plann.idplann}>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>
                                            <div className="dropdown">
                                              <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                              </button>
                                              <ul className="dropdown-menu">
                                                <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                                <li><hr className="dropdown-divider"/></li>
                                                <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                              </ul>
                                            </div>
                                          </td>
                                          <td>{plann.max_patient}</td>
                                          <td></td>
                                        </tr>
                                    );
                                  }
                            } 
                            else {
                                //jour différent
                                if (plann.indisplann) { 
                                    /*il y a indisponibilité*/
                                    if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                                      /*indisponibilité définitive*/
                                      return (<tr key={plann.idplann}>
                                            <td></td>
                                            <td></td>
                                            <td>{state.weekDay[plann.jour]}</td>
                                            <td className="text-danger">
                                              {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                            </td>
                                            <td className="text-danger">{plann.max_patient}</td>
                                            <td className="text-danger">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                          </tr>
                                      );
                                    }
                                    else {
                                      /*indisponibilité provisoire*/
                                      return (<tr key={plann.idplann}>
                                            <td></td>
                                            <td></td>
                                            <td>{state.weekDay[plann.jour]}</td>
                                            <td className="text-warning">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                  {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                                  <li><hr className="dropdown-divider"/></li>
                                                  <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                            <td className="text-warning">{plann.max_patient}</td>
                                            <td className="text-warning">
                                              <div className="dropdown">
                                                <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                                </button>
                                                <ul className="dropdown-menu">
                                                  <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                                </ul>
                                              </div>
                                            </td>
                                          </tr>
                                      );
                                    }
                                  }
                                  else {
                                    /*aucune indisponibilité en cours*/
                                    return (<tr key={plann.idplann}>
                                          <td></td>
                                          <td></td>
                                          <td>{state.weekDay[plann.jour]}</td>
                                          <td>
                                            <div className="dropdown">
                                              <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                              </button>
                                              <ul className="dropdown-menu">
                                                <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                                <li><hr className="dropdown-divider"/></li>
                                                <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                                <li><hr className="dropdown-divider"/></li>
                                                <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowAddIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Ajouter une indisponibilité</button></li>
                                              </ul>
                                            </div>
                                          </td>
                                          <td>{plann.max_patient}</td>
                                          <td></td>
                                        </tr>
                                    );
                                  }
                            }
                          } 
                          else {
                            //medecin différent
                            if (plann.indisplann) { 
                                /*il y a indisponibilité*/
                                if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                                  /*indisponibilité définitive*/
                                  return (<tr key={plann.idplann}>
                                        <td></td>
                                        <td>
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.titre+' '+plann.nom+' '+plann.prenom}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td>{state.weekDay[plann.jour]}</td>
                                        <td className="text-danger">
                                          {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                        </td>
                                        <td className="text-danger">{plann.max_patient}</td>
                                        <td className="text-danger">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}                                            </button>
                                            <ul className="dropdown-menu">
                                              <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                      </tr>
                                  );
                                }
                                else {
                                  /*indisponibilité provisoire*/
                                  return (<tr key={plann.idplann}>
                                        <td></td>
                                        <td>
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.titre+' '+plann.nom+' '+plann.prenom}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td>{state.weekDay[plann.jour]}</td>
                                        <td className="text-warning">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td className="text-warning">{plann.max_patient}</td>
                                        <td className="text-warning">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                      </tr>
                                  );
                                }
                              }
                              else {
                                /*aucune indisponibilité en cours*/
                                return (<tr key={plann.idplann}>
                                      <td></td>
                                      <td>
                                        <div className="dropdown">
                                          <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {plann.titre+' '+plann.nom+' '+plann.prenom}
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                          </ul>
                                        </div>
                                      </td>
                                      <td>{state.weekDay[plann.jour]}</td>
                                      <td>
                                        <div className="dropdown">
                                          <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowAddIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Ajouter une indisponibilité</button></li>
                                          </ul>
                                        </div>
                                      </td>
                                      <td>{plann.max_patient}</td>
                                      <td></td>
                                    </tr>
                                );
                              }
                          }
                        } 
                        else {
                            //service différent
                            if (plann.indisplann) { 
                                /*il y a indisponibilité*/
                                if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                                  /*indisponibilité définitive*/
                                  return (<tr key={plann.idplann}>
                                        <td>{plann.libelle_service}</td>
                                        <td>
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.titre+' '+plann.nom+' '+plann.prenom}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td>{state.weekDay[plann.jour]}</td>
                                        <td className="text-danger">
                                          {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                        </td>
                                        <td className="text-danger">{plann.max_patient}</td>
                                        <td className="text-danger">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}                                            </button>
                                            <ul className="dropdown-menu">
                                              <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                      </tr>
                                  );
                                }
                                else {
                                  /*indisponibilité provisoire*/
                                  return (<tr key={plann.idplann}>
                                        <td>{plann.libelle_service}</td>
                                        <td>
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.titre+' '+plann.nom+' '+plann.prenom}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td>{state.weekDay[plann.jour]}</td>
                                        <td className="text-warning">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                              <li><hr className="dropdown-divider"/></li>
                                              <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                        <td className="text-warning">{plann.max_patient}</td>
                                        <td className="text-warning">
                                          <div className="dropdown">
                                            <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                            </button>
                                            <ul className="dropdown-menu">
                                              <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                            </ul>
                                          </div>
                                        </td>
                                      </tr>
                                  );
                                }
                              }
                              else {
                                /*aucune indisponibilité en cours*/
                                return (<tr key={plann.idplann}>
                                      <td>{plann.libelle_service}</td>
                                      <td>
                                        <div className="dropdown">
                                          <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {plann.titre+' '+plann.nom+' '+plann.prenom}
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                          </ul>
                                        </div>
                                      </td>
                                      <td>{state.weekDay[plann.jour]}</td>
                                      <td>
                                        <div className="dropdown">
                                          <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                            <li><hr className="dropdown-divider"/></li>
                                            <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowAddIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Ajouter une indisponibilité</button></li>
                                          </ul>
                                        </div>
                                      </td>
                                      <td>{plann.max_patient}</td>
                                      <td></td>
                                    </tr>
                                );
                              }
                        }
                      }
                      else {
                        //structure différente donc nouvel en-tête
                        if (plann.indisplann) { 
                            /*il y a indisponibilité*/
                            if (!plann.indisfin || plann.indisfin === '0000-00-00') {
                              /*indisponibilité définitive*/
                              return (<React.Fragment key={`groupe_${plann.idplann}`}>
                                  <tr key={plann.idplann + '_a'} className="table-info">
                                    <td style={{ textAlign: 'center' }} colSpan={6}>
                                      <b>
                                        <i>{plann.libelle_structure}</i>
                                      </b>
                                    </td>
                                  </tr>
                                  <tr key={plann.idplann}>
                                    <td>{plann.libelle_service}</td>
                                    <td>
                                      <div className="dropdown">
                                        <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                          {plann.titre+' '+plann.nom+' '+plann.prenom}
                                        </button>
                                        <ul className="dropdown-menu">
                                          <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                          <li><hr className="dropdown-divider"/></li>
                                          <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td>{state.weekDay[plann.jour]}</td>
                                    <td className="text-danger">
                                      {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                    </td>
                                    <td className="text-danger">{plann.max_patient}</td>
                                    <td className="text-danger">
                                      <div className="dropdown">
                                        <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle text-danger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - ##/##/####'}                                        </button>
                                        <ul className="dropdown-menu">
                                          <li><button className="dropdown-item" onClick={() => handleShowEndIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.motif)}>Terminer la suspension</button></li>
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                            else {
                              /*indisponibilité provisoire*/
                              return (<React.Fragment key={`groupe_${plann.idplann}`}>
                                  <tr key={plann.idplann + '_a'} className="table-info">
                                    <td style={{ textAlign: 'center' }} colSpan={6}>
                                      <b>
                                        <i>{plann.libelle_structure}</i>
                                      </b>
                                    </td>
                                  </tr>
                                  <tr key={plann.idplann}>
                                    <td>{plann.libelle_service}</td>
                                    <td>
                                      <div className="dropdown">
                                        <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                          {plann.titre+' '+plann.nom+' '+plann.prenom}
                                        </button>
                                        <ul className="dropdown-menu">
                                          <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                          <li><hr className="dropdown-divider"/></li>
                                          <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td>{state.weekDay[plann.jour]}</td>
                                    <td className="text-warning">
                                      <div className="dropdown">
                                        <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                          {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                        </button>
                                        <ul className="dropdown-menu">
                                          <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                          <li><hr className="dropdown-divider"/></li>
                                          <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td className="text-warning">{plann.max_patient}</td>
                                    <td className="text-warning">
                                      <div className="dropdown">
                                        <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {dayjs(plann.indisdebut).format('DD/MM/YYYY')+' - '+dayjs(plann.indisfin).format('DD/MM/YYYY')}
                                        </button>
                                        <ul className="dropdown-menu">
                                          <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowExtendIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient, plann.indisplann, plann.indisdebut, plann.indisfin, plann.motif)}>Prolonger la suspension</button></li>
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          }
                          else {
                            /*aucune indisponibilité en cours*/
                            return (<React.Fragment key={`groupe_${plann.idplann}`}>
                                <tr key={plann.idplann + '_a'} className="table-info">
                                  <td style={{ textAlign: 'center' }} colSpan={6}>
                                    <b>
                                      <i>{plann.libelle_structure}</i>
                                    </b>
                                  </td>
                                </tr>
                                <tr key={plann.idplann}>
                                  <td>{plann.libelle_service}</td>
                                  <td>
                                    <div className="dropdown">
                                      <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {plann.titre+' '+plann.nom+' '+plann.prenom}
                                      </button>
                                      <ul className="dropdown-menu">
                                        <li key={plann.idplann+'_aa'}><button className="dropdown-item" type="button" onClick={() => handleShowTarif(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.prix)}>Modifier le tarif</button></li>
                                        <li><hr className="dropdown-divider"/></li>
                                        <li key={plann.idplann+'_bb'}><button className="dropdown-item" type="button" onClick={() => handleShowPlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplanning, plann.id_medecin)}>Ajouter un créneau</button></li>
                                      </ul>
                                    </div>
                                  </td>
                                  <td>{state.weekDay[plann.jour]}</td>
                                  <td>
                                    <div className="dropdown">
                                      <button style={{color: 'inherit', textDecoration: 'none', padding: 0}} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {plann.heure_debut.split(':')[0] + 'h' + plann.heure_debut.split(':')[1]+' - '+plann.heure_fin.split(':')[0] + 'h' + plann.heure_fin.split(':')[1]}
                                      </button>
                                      <ul className="dropdown-menu">
                                        <li key={plann.idplann+'_cc'}><button className="dropdown-item" type="button" onClick={() => handleShowQuota(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Modifier la limite patients</button></li>
                                        <li><hr className="dropdown-divider"/></li>
                                        <li key={plann.idplann+'_dd'}><button className="dropdown-item" type="button" onClick={() => handleShowDeletePlann(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Supprimer le créneau</button></li>
                                        <li><hr className="dropdown-divider"/></li>
                                        <li key={plann.idplann+'_ee'}><button className="dropdown-item" type="button" onClick={() => handleShowAddIndis(plann.libelle_structure, plann.libelle_service, plann.titre, plann.nom, plann.prenom, plann.idplann, plann.jour, plann.heure_debut, plann.heure_fin, plann.max_patient)}>Ajouter une indisponibilité</button></li>
                                      </ul>
                                    </div>
                                  </td>
                                  <td>{plann.max_patient}</td>
                                  <td></td>
                                </tr>
                              </React.Fragment>
                            );
                          }
                    }
                    }
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="alert alert-info">Aucune donnée disponible.</div>
          )}

            <Modal show={state.showModal} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Ajouter une prestation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Service</label>
                    <Select
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      placeholder="Sélectionner le service"
                      options={state.service || []}
                      onChange={(e) => setState(prev => ({ ...prev, idservice: e ? e.value : null }))}
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      noOptionsMessage={() => 'Aucun service trouvé'}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Médecin</label>
                    <Select
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      placeholder="Sélectionner le médecin"
                      options={state.optionsDoc || []}
                      onChange={(e) => setState(prev => ({ ...prev, iddoctor: e ? e.value : null }))}
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      noOptionsMessage={() => 'Aucun médecin trouvé'}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Jour</label>
                    <Select options={state.weekDay2} value={state.weekDay2.find(o => o.value === state.jour) || null} onChange={onChangeJour} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Heure début</label>
                    <input type="time" className="form-control" value={state.hdeb || ''} onChange={onChangeHdeb} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Heure fin</label>
                    <input type="time" className="form-control" value={state.hfin || ''} onChange={onChangeHfin} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tarif (€)</label>
                    <input type="number" className="form-control" value={state.tarif_u || ''} onChange={onChangeTarif_u} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Limite patients</label>
                    <input type="number" className="form-control" value={state.maxpatient || ''} onChange={onChangeMaxpatient} />
                  </div>
                </div>
                {state.mess_erreur && <div className="alert alert-danger mt-3">{state.mess_erreur}</div>}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Annuler</Button>
                <Button variant="primary" onClick={savePrestation} disabled={!isPrestationFormValid}>Sauvegarder</Button>
              </Modal.Footer>
            </Modal>
          <Modal show={state.showModalTarif} onHide={handleCloseTarif}>
            <Modal.Header closeButton>
              <Modal.Title>Modifier le tarif</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Structure: {state.libstr_u || 'undefined'}</p>
              <p>Service: {state.libser_u || 'undefined'}</p>
              <p>Médecin: {state.doc_u || 'undefined'}</p>
              <div className="mb-3">
                <label className="form-label">Tarif:</label>
                <input
                  type="number"
                  className="form-control"
                  value={state.tarif_u || ''}
                  onChange={onChangeTarif_u}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseTarif}>Annuler</Button>
              <Button variant="primary" onClick={saveTarif}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalPlann} onHide={handleClosePlann}>
            <Modal.Header closeButton>
              <Modal.Title>Ajouter un créneau</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-2 text-muted">
                <div>Structure: {state.libstr_u}</div>
                <div>Service: {state.libser_u}</div>
                <div>Médecin: {state.doc_u}</div>
              </div>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Jour</label>
                  <Select
                    classNamePrefix="select"
                    isClearable
                    isSearchable
                    placeholder="Sélectionner le jour"
                    options={state.weekDay2}
                    value={state.weekDay2.find(o => o.value === state.jour) || null}
                    onChange={(opt) => setState(prev => ({ ...prev, jour: opt ? opt.value : null }))}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Heure début</label>
                  <input type="time" className="form-control" value={state.hdeb || ''} onChange={(e) => setState(prev => ({ ...prev, hdeb: e.target.value }))} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Heure fin</label>
                  <input type="time" className="form-control" value={state.hfin || ''} onChange={(e) => setState(prev => ({ ...prev, hfin: e.target.value }))} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Limite patients</label>
                  <input type="number" className="form-control" value={state.maxpatient || ''} onChange={(e) => setState(prev => ({ ...prev, maxpatient: e.target.value }))} />
                </div>
              </div>
              {state.mess_erreur && <div className="alert alert-danger mt-3">{state.mess_erreur}</div>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClosePlann}>Annuler</Button>
              <Button variant="primary" onClick={savePlann} disabled={!isPlannFormValid}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalQuota} onHide={handleCloseQuota}>
            <Modal.Header closeButton>
              <Modal.Title>Modifier la limite patients</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Structure: {state.libstr_u}</p>
              <p>Service: {state.libser_u}</p>
              <p>Médecin: {state.doc_u}</p>
              <p>Jour: {state.weekDay[state.jour]}</p>
              <p>Horaire: {state.hdeb} - {state.hfin}</p>
              <div className="mb-3">
                <label className="form-label">Limite patients:</label>
                <input type="number" className="form-control" value={state.maxpatient || ''} onChange={onChangeMaxpatient} />
              </div>
              {state.mess_erreur && <div className="alert alert-danger">{state.mess_erreur}</div>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseQuota}>Annuler</Button>
              <Button variant="primary" onClick={saveQuota}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalDeletePlann} onHide={handleCloseDeletePlann}>
            <Modal.Header closeButton>
              <Modal.Title>Supprimer le créneau</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Structure: {state.libstr_u}</p>
              <p>Service: {state.libser_u}</p>
              <p>Médecin: {state.doc_u}</p>
              <p>Jour: {state.weekDay[state.jour]}</p>
              <p>Horaire: {state.hdeb} - {state.hfin}</p>
              <p>Limite patients: {state.maxpatient}</p>
              {state.mess_erreur && <div className="alert alert-danger">{state.mess_erreur}</div>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseDeletePlann}>Annuler</Button>
              <Button variant="danger" onClick={confirmDeletePlann}>Supprimer</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalAddIndis} onHide={handleCloseAddIndis}>
            <Modal.Header closeButton>
              <Modal.Title>Ajouter une indisponibilité</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-2 text-muted">
                <div>Structure: {state.libstr_u}</div>
                <div>Service: {state.libser_u}</div>
                <div>Médecin: {state.doc_u}</div>
                <div>Jour et heure: {state.weekDay[state.jour]+', '+state.hdeb+'-'+state.hfin}</div>
                <div>Limite patients: {state.maxpatient}</div>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    isClearable
                    minDate={new Date()}
                    selected={state.debutIndis}
                    onChange={onChangeDebutIndis}
                    dateFormat="dd/MM/yyyy"
                    customInput={<input type="text" className="form-control" />}
                    placeholderText="Date de début"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    isClearable
                    minDate={state.debutIndis || new Date()}
                    selected={state.finIndis}
                    onChange={onChangeFinIndis}
                    dateFormat="dd/MM/yyyy"
                    customInput={<input type="text" className="form-control" />}
                    placeholderText="Date de fin"
                  />
                </div>
                <div className="col-12">
                  <input type="text" className="form-control" value={state.motifIndis || ''} onChange={onChangeMotifIndis} placeholder="Motif" />                </div>
              </div>
              {state.mess_erreur && <div className="alert alert-danger mt-3">{state.mess_erreur}</div>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseAddIndis}>Annuler</Button>
              <Button variant="primary" onClick={saveAddIndis} disabled={!isAddIndisFormValid}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalEndIndis} onHide={handleCloseEndIndis}>
            <Modal.Header closeButton>
              <Modal.Title>Terminer la suspension</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-2 text-muted">
                <div>Structure: {state.libstr_u}</div>
                <div>Service: {state.libser_u}</div>
                <div>Médecin: {state.doc_u}</div>
                <div>Jour et heure: {state.weekDay[state.jour]+', '+state.hdeb+'-'+state.hfin}</div>
                <div>Début: {state.indisdebut_u ? dayjs(state.indisdebut_u).format('DD/MM/YYYY') : ''}</div>
                <div>Motif: {state.motif_u}</div>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    isClearable={false}
                    minDate={(state.indisdebut_u && new Date(state.indisdebut_u) > new Date()) ? new Date(state.indisdebut_u) : new Date()}
                    filterDate={(date) => {
                      const today = new Date(); today.setHours(0,0,0,0);
                      const start = state.indisdebut_u ? new Date(state.indisdebut_u) : null;
                      if (start) start.setHours(0,0,0,0);
                      const d = new Date(date); d.setHours(0,0,0,0);
                      return d >= today && (!start || d >= start);
                    }}
                    selected={state.finIndis2}
                    onChange={onChangeFinIndis2}
                    dateFormat="dd/MM/yyyy"
                    customInput={<input type="text" className="form-control" />}
                    placeholderText="Date de fin"
                    required
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseEndIndis}>Annuler</Button>
              <Button variant="primary" onClick={saveEndIndis} disabled={!isEndIndisFormValid}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={state.showModalExtendIndis} onHide={handleCloseExtendIndis}>
            <Modal.Header closeButton>
              <Modal.Title>Prolonger la suspension</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-2 text-muted">
                <div>Structure: {state.libstr_u}</div>
                <div>Service: {state.libser_u}</div>
                <div>Médecin: {state.doc_u}</div>
                <div>Jour et heure: {state.weekDay[state.jour]+', '+state.hdeb+'-'+state.hfin}</div>
                <div>Début: {state.indisdebut_u ? dayjs(state.indisdebut_u).format('DD/MM/YYYY') : ''}</div>
                <div>Fin actuelle: {state.indisfin_u ? dayjs(state.indisfin_u).format('DD/MM/YYYY') : '—'}</div>
                <div>Motif: {state.motif_u}</div>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    isClearable={false}
                    minDate={state.indisfin_u ? new Date(state.indisfin_u) : new Date()}
                    filterDate={(date) => !state.indisfin_u || date > new Date(state.indisfin_u)}
                    selected={state.finIndis3}
                    onChange={onChangeFinIndis3}
                    dateFormat="dd/MM/yyyy"
                    customInput={<input type="text" className="form-control" />}
                    placeholderText="Nouvelle date de fin"
                    required
                  />
                </div>
              </div>
              {state.mess_erreur && <div className="alert alert-danger mt-3">{state.mess_erreur}</div>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseExtendIndis}>Annuler</Button>
              <Button variant="primary" onClick={saveExtendIndis} disabled={!isExtendIndisFormValid}>Sauvegarder</Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default HomeMng;
